import { Box, Card, CardBody, SimpleGrid, Stack, Text } from "@chakra-ui/react";

import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const MetricExpenseCard = ({
  title = "",
  percentage = "-",
  total = "-",
  perfectPL = "-",
  color = "black",
  type = "",
  triggerExpenseBreakdown,
  setBreakdownData,
}) => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleClick = () => {
    if (type) {
      navigate(`/lucro-metrics/${type}/${"performance"}`, {
        state: { from: location.pathname },
      });

      triggerExpenseBreakdown?.(true);
    }
  };
  return (
    <Stack width="100%" align="center" p="0px 0px">
      <Card
        role="group"
        width="100%"
        height={"143px"}
        borderRadius="12px"
        onClick={handleClick}
        _hover={{ boxShadow: "xl", cursor: "pointer" }}
      >
        <CardBody padding={"12px"}>
          <Box align={"center"}>
            <Text
              gridColumn={1}
              gridRow={1}
              fontSize="16px"
              margin={0}
              textAlign="center"
              color={"#202224"}
            >
              {title}
            </Text>
            <Box gridColumn={2} gridRow={1} color="#536DEC" textAlign="right">
              {/* <Image
                  src="/metric-expense-arrow.png"
                  alt="Client Navigation Open"
                  boxSize="40px"
                  objectFit="contain"
                  position="absolute"
                  top="50%"
                  right="0"
                  transform="translateY(-50%)"
                  _groupHover={{
                    filter: "brightness(1.2)",
                  }}
                /> */}
            </Box>
            <Text fontSize={"28px"} fontWeight={800} margin={0} color={color}>
              {percentage}
            </Text>
          </Box>
          <SimpleGrid
            templateColumns={"14fr 5fr 14fr"}
            align="center"
            p={"5px 0px 0px"}
          >
            <Box
              p={0}
              height={"60px"}
              gridColumn={1}
              gridRow={1}
              textAlign={"center"}
            >
              <Text fontSize={"14px"} margin={0} color={"#202224"}>
                Perfect P&L
              </Text>
              <Text
                fontSize={"clamp(15px, 5vw, 17px)"}
                fontWeight={600}
                margin={0}
                gridColumn={1}
                gridRow={2}
                whiteSpace={"nowrap"}
              >
                {perfectPL === "No Target" ? "No Target" : `Below ${perfectPL}`}
              </Text>
            </Box>
            <Box
              textAlign={"center"}
              align={"center"}
              justifyContent={"center"}
              display={"flex"}
            >
              <Box
                gridColumn={2}
                gridRow={1}
                height={"50px"}
                border={"1px"}
                width="0px"
                borderColor={"gray.200"}
              ></Box>
            </Box>
            <Box gridColumn={3} gridRow={1} textAlign={"center"}>
              <Text fontSize={"14px"} margin={0} color={"#202224"}>
                Total
              </Text>
              <Text
                fontSize={"clamp(15px, 5vw, 17px)"}
                fontWeight={600}
                margin={0}
                gridColumn={2}
                gridRow={2}
                whiteSpace={"nowrap"}
              >
                {total}
              </Text>
            </Box>
          </SimpleGrid>
        </CardBody>
      </Card>
    </Stack>
  );
};

export default MetricExpenseCard;
